import React, {useContext, useEffect, useState} from "react";
import BrandsSubmenu from "./BrandsSubmenu";
import ModelsSubmenu from "./ModelsSubmenu";
import ProductSubmenu from "./ProductSubmenu";
import SegmentsSubmenu from "./SegmentsSubmenu";
import BudgetSubmenu from "./BudgetSubmenu";
import OffersSubmenu from "./OffersSubmenu";

import closeIcon from "../../assets/images/icons/close.svg";
import phoneIconWhite from "../../assets/images/icons/phone-white.svg";
import {SearchOptionsContext} from "../../context/search-options-context";
import {FavouriteVehiclesContext} from "../../context/favourite-vehicles-context";
import {Link, useHistory} from "react-router-dom";
import analyitics from "../../utils/analytics";
import SearchField from "../SearchField/SearchField";
import URLSearchParamsConverter from "../../utils/URLSearchParamsConverter";
import {Icon} from "@blueprintjs/core";
import {IconNames} from "@blueprintjs/icons";

function ProductMenu(props) {

    let searchOptions = useContext(SearchOptionsContext);
    const favouriteVehicles = useContext(FavouriteVehiclesContext);
    const favouritesCount = favouriteVehicles ? favouriteVehicles.value : 0;
    const history = useHistory();

    // Mobile drill-in navigation: null | 'offers'
    const [mobileSubmenu, setMobileSubmenu] = useState(null);

    // Reset the drill-in whenever the mobile panel is closed / switched.
    useEffect(() => {
        if (!props.showInMobile || props.mobilePanelMode !== 'menu') {
            setMobileSubmenu(null);
        }
    }, [props.showInMobile, props.mobilePanelMode]);

    const submenuTitles = {
        offers: 'Wszystkie oferty'
    };

    let showStyle = props.showInMobile ? {
        display: "block"
    } : null;

    const onConfigureClickHandler = () => {
        analyitics.sendEvent({
            category: 'Konfiguruj',
            action: 'Kliknięcie w link do Konfuguruj'
        });
        props.closeClicked();
    }

    let carSelectedHandler = (car) => {
        searchButtonClickHandler(car);
    }

    let searchButtonClickHandler = (car) => {
        analyitics.sendEvent({
            category: 'Wyszukiwarka',
            action: 'Kliknięcie w lupkę'
        });

        let searchParameters = {
            brands: (car.brand ? [{name: car.brand}] : []),
            models: (car.model ? [{name: car.model}] : []),
            nip: (car.nip ? [{name: car.nip}] : [])
        }

        history.push({
            pathname: "/lista-ofert",
            search: URLSearchParamsConverter.createURLSearchString(searchParameters)
        });
        props.closeClicked();
    }

    const onUsedCarsClickHandler = () => {
        history.push({
            pathname: "/lista-ofert",
            search: URLSearchParamsConverter.createURLSearchString({newUsed: 'used'})
        });
        props.closeClicked();
    }

    const onSearchBtnClick = () => {
        history.push('/lista-ofert');
        props.closeClicked();
    }

    const onFavouritesClickHandler = () => {
        history.push('/ulubione');
        props.closeClicked();
    }

    const showMenuItems = !props.mobilePanelMode || props.mobilePanelMode === 'menu';
    const showSearch = !props.mobilePanelMode || props.mobilePanelMode === 'search';

    return (
        <div id="product-menu" style={showStyle}>

            {/* Mobile-only topbar */}
            <div className="mobile-pm-header">
                {props.mobilePanelMode === 'menu' && mobileSubmenu && (
                    <button className="mobile-pm-header__back btn-clean" onClick={() => setMobileSubmenu(null)} aria-label="Wróć">
                        <span className="mobile-pm-header__back-icon"><i className="fa fa-chevron-left"/></span>
                        <span className="mobile-pm-header__title">{submenuTitles[mobileSubmenu]}</span>
                    </button>
                )}
                {props.mobilePanelMode === 'menu' && !mobileSubmenu && (
                    <a href={"tel:" + (props.phone || '729086940')} className="mobile-pm-header__phone">
                        <span className="mobile-pm-header__phone-icon">
                            <img src={phoneIconWhite} alt=""/>
                        </span>
                        <span className="mobile-pm-header__phone-text">{props.phone || '729 086 940'}</span>
                    </a>
                )}
                {props.mobilePanelMode === 'search' && (
                    <span className="mobile-pm-header__title">Wyszukiwarka</span>
                )}
                <button className="mobile-pm-header__close btn-clean" onClick={props.closeClicked} aria-label="Zamknij">✕</button>
            </div>

            <span className="as-link mobileProductMenuClose" onClick={props.closeClicked}><img src={closeIcon} alt="close"/></span>
            <div id="product-menu-wrapper" className="container flex">
                {showMenuItems && mobileSubmenu === 'offers' && (
                    <div className="mobile-submenu-view">
                        <OffersSubmenu brands={searchOptions.brandsAndModels} onClose={props.closeClicked}/>
                    </div>
                )}
                {showMenuItems && !mobileSubmenu && (
                    <>
                        <ProductSubmenu name={"Wszystkie oferty"} id="menu-item-wszystkie" href="/lista-ofert" onClose={props.closeClicked} onMobileExpand={() => setMobileSubmenu('offers')}>
                            <OffersSubmenu brands={searchOptions.brandsAndModels}/>
                        </ProductSubmenu>
                        <Link to="/konfiguruj" className="product-menu-item" id="menu-item-konfigurator" onClick={onConfigureClickHandler}>
                            <span>Konfiguruj ofertę</span>
                        </Link>
                        <Link to="/gwarancja-zwrotu" className="product-menu-item" onClick={props.closeClicked}>
                            <span>Gwarancja zwrotu</span>
                        </Link>
                        <span className="product-menu-item" onClick={onUsedCarsClickHandler}>
                            <span>Auta używane</span>
                        </span>
                        <Link to="/blog" className="product-menu-item" onClick={props.closeClicked}>
                            <span>Blog</span>
                        </Link>
                        <Link to="/kontakt" className="product-menu-item" onClick={props.closeClicked}>
                            <span>Kontakt</span>
                        </Link>
                    </>
                )}
                {showSearch && (
                    <div className="mobile-search-wrapper">
                        <div className="top-search">
                            <SearchField onItemSelect={carSelectedHandler}/>
                        </div>
                        <button className="mobile-szukaj-btn" onClick={onSearchBtnClick}>
                            <span>SZUKAJ</span>
                            <span className="mobile-szukaj-btn__icon"><i className="fa fa-chevron-right"/></span>
                        </button>
                    </div>
                )}
            </div>

            {/* Mobile-only "Ulubione auta" footer — top-level menu list only */}
            {showMenuItems && !mobileSubmenu && (
                <div className="mobile-pm-favourites">
                    <button type="button" className="mobile-pm-favourites__btn" onClick={onFavouritesClickHandler}>
                        <span className="mobile-pm-favourites__icon">
                            <Icon icon={IconNames.HEART} iconSize={18} color="#176fb7"/>
                            <span className="mobile-pm-favourites__badge">{favouritesCount}</span>
                        </span>
                        <span className="mobile-pm-favourites__label">Ulubione auta</span>
                    </button>
                </div>
            )}
        </div>
    );
}

export default ProductMenu;
